import { isCatsaExtrasApplicable, isMsdNotificationApplicable, isTroubleshootingApplicable } from '@/Pages/WorkOrders/Modals/catsaExtras.js';
import { isImpactAssessmentApplicable } from '@/Pages/WorkOrders/Modals/impactAssessment.js';
import { computed, toValue } from 'vue';

// Computes the CATSA-extras / impact-assessment section gates for a work order.
export function useWorkOrderSectionGates({ workOrderType, asset, caseCategory, catsaExtras, msdNotification, impactAssessment }) {
    const type = () => toValue(workOrderType);
    const resolvedAsset = () => toValue(asset);
    const cc = () => toValue(caseCategory);
    const operability = () => resolvedAsset()?.status?.operability ?? null;

    return {
        catsaExtrasEnabled: computed(() => isCatsaExtrasApplicable(type(), catsaExtras)),
        troubleshootingEnabled: computed(() => isTroubleshootingApplicable(cc(), type(), catsaExtras)),
        msdNotificationEnabled: computed(() => isMsdNotificationApplicable(resolvedAsset()?.type?.value, cc(), type(), catsaExtras, msdNotification)),
        impactAssessmentEnabled: computed(() =>
            isImpactAssessmentApplicable(resolvedAsset()?.critical, cc(), operability(), type(), impactAssessment, catsaExtras),
        ),
    };
}
